module.exports = __webpack_public_path__ + "static/media/Yoyo_6611.8b6ecefe.jpg";